import svg4everybody from 'svg4everybody'
import $ from 'jquery'

import scroll from './scroll'
import demo from '../blocks/demo/demo'
import instagram from '../blocks/instagram/instagram'
import howto from '../blocks/howto/howto'
import manual from '../blocks/manual/manual'

import showModal from './modal'

$(() => {
  const manualElement = document.getElementById('manual')
  if (location.hash === '#manual') {
    showModal(manualElement)
  }

  $(window).on('hashchange', function (e) {
    if (location.hash === '#manual') {
      showModal(manualElement)
    }
  })

  svg4everybody()
  demo()
  instagram()
  howto()
  manual()
  scroll()

  $('#phone-close').on('click', function (e) {
    e.preventDefault()
    $('#rotate').css({ display: 'none' })
  })
})



// WEBPACK FOOTER //
// ./app/scripts/app.js